// extracted by mini-css-extract-plugin
export default {"link":"sf2ckG","root":"Qda9GF","label":"Mgn2mH"};